"use client";

import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import PropTypes from "prop-types";

/**
 * A reusable Lottie animation component that fetches a Lottie JSON file
 * from the given path and renders it using `lottie-react`.
 *
 * @param {Object} props - Component props.
 * @param {string} props.animationPath - Path to the Lottie JSON file (should be in /public folder).
 * @param {boolean} [props.isLoop=true] - Whether the animation should loop.
 * @param {string|number} [props.width] - Width of the animation container.
 * @param {string|number} [props.height] - Height of the animation container.
 * @param {boolean} [props.hasPlaceHolder=false] - Whether to show a placeholder while loading.
 * @param {string} [props.classes] - Additional CSS classes for the container.
 * @param {string} [props.placeholderImageUrl] - Fallback image URL when fallBackVariant is "image".
 * @param {string} [props.fallBackVariant="image"] - Placeholder variant: "image" or "skeleton".
 *
 * @returns {JSX.Element|null} The rendered Lottie animation or placeholder while loading.
 */
const GridLottieComponent = ({ animationPath, isLoop = true }) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    if (animationPath) {
      fetch(animationPath)
        .then((res) => res.json())
        .then((data) => setAnimationData(data))
        .catch((err) => console.error("Failed to load Lottie JSON:", err));
    }
  }, [animationPath]);

  return (
    <div>
      <Lottie
        animationData={animationData}
        loop={isLoop}
        style={{ width: "100%", height: "100%" }}
        rendererSettings={{
          preserveAspectRatio: "xMidYMid meet",
        }}
      />
    </div>
  );
};

GridLottieComponent.propTypes = {
  animationPath: PropTypes.string.isRequired,
  isLoop: PropTypes.bool,
};

export default GridLottieComponent;
